import * as React from "react";
import { Link } from "react-router-dom";
import config from "../../../../config/config.json";

import i18n from '../i18n';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toTop = this.toTop.bind(this);
  }

  toTop(e) {
    this.props.onToTopBtnClick();
  }

  render() {
    return (
      <div className="footer">
        <div className="footer-cont">
          <div className="footer-cell">
            <div className="footer-cell-menu">
              <h4 className="footer-cell-heading">{i18n.t('footer.title1')}</h4>
              <ul className="footer-cell-menu-list">
                <li className="footer-cell-menu-list-item">
                  <Link
                    to={config.pages.ke_stazeni.url}
                    className="footer-cell-link"
                  >
                    {i18n.t('download.breadcrumb')}
                  </Link>
                </li>
                <li className="footer-cell-menu-list-item">
                  <Link to={config.pages.gdpr.url} className="footer-cell-link">
                    {i18n.t('gdpr.titleShortcuts')}
                  </Link>
                </li>
                <li className="footer-cell-menu-list-item">
                  <Link
                    to={config.pages.privacy.url}
                    className="footer-cell-link"
                  >
                    {i18n.t('gdpr.titleShort')}
                  </Link>
                </li>
                <li className="footer-cell-menu-list-item">
                  <Link
                      to={config.pages.terms_conditions.url}
                      className="footer-cell-link"
                  >
                    {i18n.t('terms_conditions.title')}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer-cell-map-container">
              <h4 className="footer-cell-heading">{i18n.t('footer.title2')}</h4>
              <div className="footer-cell-kontakt">
                <div className="footer-cell-kontakt-half">
                  <span className="footer-cell-kontakt-heading">Mrmont s.r.o.</span>
                  <br />
                  IČO: 23329319
                  <br />
                  DIČ: CZ23329319
                </div>
                <div className="footer-cell-kontakt-half">
                  <span className="footer-cell-kontakt-telephone">
                    T:&nbsp;&nbsp;
                  </span>
                  +420 797 800 100
                  <br />
                  <span className="footer-cell-kontakt-telephone">
                    E:&nbsp;&nbsp;
                  </span>
                  info@heatflow.cz
                  <br />
                  <span className="footer-cell-kontakt-address">
                    Vratimovská 624/11, Ostrava, 718 00
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-cell">
            <div className="footer-cell-loga-grid">
              <h4 className="footer-cell-heading">Mrmont s.r.o.</h4>
              <img
                className="footer-logo-fusion"
                src={config.paths.brands + "logo_mrmont.png"}
                alt="Mrmont s.r.o."
              />
              <div className="footer-reseni-popis">
                Vratimovská 624/11<br />
                Ostrava, 718 00<br />
                <br />
                T: +420 797 800 100<br />
                E: info@heatflow.cz
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          © Copyright 2013-{new Date().getFullYear()} Mrmont s.r.o. {i18n.t('footer.allRightReserved')} | <Link
            to={config.pages.terms_conditions.url}
            className="footer-link"
            target="_blank" rel="noopener noreferrer"
        >
          {i18n.t('terms_conditions.title')}
        </Link>
          <div className="footer-to-top" onClick={this.toTop}>
            <img
              className="footer-to-top-link"
              src={config.paths.icons + "ic_arrow_up_white.png"}
              alt="Nahoru"
            />
          </div>
        </div>
      </div>
    );
  }
}

export { Footer };
